import { clsx as cx } from 'clsx';
import * as React from 'react';
import { getDeviceStyles } from '../../styles/tab/getDeviceStyles';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType';
export var Tab = function Tab(_ref) {
  var title = _ref.title,
    disabled = _ref.disabled,
    active = _ref.active,
    focusVisible = _ref.focusVisible,
    onClick = _ref.onClick;
  var deviceType = useDeviceType();
  var styles = getDeviceStyles(deviceType);
  return /*#__PURE__*/React.createElement("button", {
    disabled: disabled,
    type: "button",
    role: "tab",
    "aria-selected": active,
    tabIndex: active ? 0 : -1,
    className: cx(styles['tab'], active && styles['active'], focusVisible && styles['focus-visible']),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, title));
};